import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { style: {"text-align":"right","margin-bottom":"20px"} }
const _hoisted_2 = { style: {"display":"flex","justify-content":"center","align-items":"center"} }

import { h, reactive, onMounted, ref, unref } from 'vue';
import { useRouter } from 'vue-router';
import { ElButton, ElSwitch, ElTag, ElMessage } from 'element-plus';
import { GbTables } from '@/components/GbTables';
import { useGbTable } from '@/hooks/useGbTable';
import { useDictionary } from '@/store/dictionary.store';
import { GetPartType } from '../../helpers/statusHelpers';
import { GetCpListApi, CpDeleteApi, CtChgEnabledApi } from '@/apis/counterpart/counterpart.api';

import PartyBEditor from './components/editorDialog.vue';

import moment from 'moment';

// 导入多语言hook
import { useLocales } from '@/hooks/useLocales';


export default /*#__PURE__*/_defineComponent({
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const partyBEditorRef = ref<InstanceType<typeof PartyBEditor>>();



const { getSelectList } = useDictionary();

// 获取多语言翻译函数
const { t } = useLocales();

/* GbTable 配置 */
const { register, tableObject, methods } = useGbTable<any>({
	getListApi: GetCpListApi,
	delListApi: CpDeleteApi,
	response: { data: 'data', total: 'total' },
});

const { push } = useRouter();
const { setSearchParams } = methods;

const state = reactive({
	loading: false,
	search: { part_type_id: '', tenant_id: '1' } as any,
	paged: { current: 1, page_size: 20 },
});

/* 数据Table绑定设置 */
const tabColumns = reactive<any[]>([
	{ field: 'name', label: t('consignee.table.fullName', '相对方全称'), columnWidth: '180' },
	{ field: 'no', label: t('consignee.table.no', '相对方编号'), columnWidth: '150' },
	{ field: 'short_name', label: t('consignee.table.shortName', '相对方简称'), columnWidth: '120' },
	{ field: 'code', label: t('consignee.table.creditCode', '统一社会信用代码'), columnWidth: '180' },
	{ field: 'part_type_id', label: t('consignee.table.enterpriseType', '企业类型'), columnWidth: '90', align: 'center' },
	{ field: 'remark', label: t('consignee.table.remark', '备注') },
	{ field: 'is_enabled', label: t('consignee.table.status', '状态'), columnWidth: '80', fixed: 'right', align: 'center' },
	{ field: 'create_user_name', label: t('consignee.table.creator', '创建人'), columnWidth: '100', fixed: 'right' },
	{ field: 'created_time', label: t('consignee.table.createdTime', '创建时间'), columnWidth: '120', fixed: 'right' },
	{ field: 'action', width: '150px', label: t('consignee.table.action', '操作'), fixed: 'right', align: 'center' },
]);

const actions = {
	search: () => {
		const searchInput = Object.assign({}, state.search, state.paged);
		methods.setSearchParams(searchInput);
	},
	reSetSearch: () => {
		state.search = {};
		methods.resetParams(state.search);
	},
	preview: (row: any) => {
		// push({ path: `/contracts/previews`, query: { contractId: `${row.id}` } });
	},
	/* 新增 */
	creation: () => {
		unref(partyBEditorRef)?.openDialog();
	},
	/* 修改 */
	editors: (row: any) => {
		unref(partyBEditorRef)?.openDialog(row);
	},
	asyncErp: () => {},
	delete: async (row: any) => {
		const delParams = { id: row.id, revision: row.revision };
		await methods.deleteRows(delParams);
	},
};

/* 启用/停用 */
const onEnabledSwithcChange = async (row: any) => {
	const response = await CtChgEnabledApi(row);
	if (response.succeeded) {
		ElMessage.success(t('consignee.message.enableStatusSuccess', '启用状态切换成功'));
	} else {
		ElMessage.success(`${t('consignee.message.enableStatusFailed', '启用状态切换失败，原因可能是：')}${response.errors}`);
	}
	setSearchParams({ tenant_id: 1 });
};

/* el-tag样式转换 */
const getElType = (partTypeID: string): any => {
	return GetPartType(partTypeID).color;
};

onMounted(async () => {
	tableObject.pageSize = 20;
	actions.search();
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_More = _resolveComponent("More")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, {
      shadow: "never",
      "body-style": { paddingBottom: '0' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          size: "small",
          model: _unref(state).search,
          inline: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: _unref(t)('consignee.form.supplierNo', '供应商编号'),
              prop: "no"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: _unref(state).search.no,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).search.no) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: _unref(t)('consignee.form.supplierName', '供应商名称'),
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: _unref(state).search.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).search.name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: _unref(t)('consignee.form.supplierCategory', '供应商类别')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  style: {"width":"100%"},
                  modelValue: _unref(state).search.part_type_id,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).search.part_type_id) = $event)),
                  clearable: "",
                  placeholder: _unref(t)('consignee.form.supplierCategory', '供应商类别'),
                  onChange: actions.search
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getSelectList)('part_type_id', true), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "onChange"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElButton), {
                      icon: "Refresh",
                      onClick: actions.reSetSearch
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('buttons.reset', '重置')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_unref(ElButton), {
                      type: "primary",
                      icon: "Search",
                      onClick: actions.search
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('buttons.search', '查询')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "never",
      style: {"margin-top":"10px"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_button_group, null, {
            default: _withCtx(() => [
              _createVNode(_unref(ElButton), {
                size: "small",
                onClick: actions.asyncErp
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('consignee.buttons.syncErpData', '同步ERP数据')), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_unref(ElButton), {
                size: "small",
                type: "primary",
                onClick: actions.creation
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('consignee.buttons.addConsignee', '新增相对方')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _createVNode(_unref(GbTables), {
          pageSize: _unref(tableObject).pageSize,
          "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((_unref(tableObject).pageSize) = $event)),
          currentPage: _unref(tableObject).currentPage,
          "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event: any) => ((_unref(tableObject).currentPage) = $event)),
          columns: _unref(tabColumns),
          data: _unref(tableObject).tableList,
          loading: _unref(tableObject).loading,
          pagination: { total: _unref(tableObject).total },
          selection: false,
          onRegister: _unref(register)
        }, {
          created_time: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(_unref(moment)(row.created_time).format('YYYY/MM/DD HH:mm')), 1)
          ]),
          part_type_id: _withCtx(({ row }) => [
            _createVNode(_unref(ElTag), {
              size: "small",
              effect: "light",
              type: getElType(row.part_type_id)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(GetPartType)(row.part_type_id).text), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          is_enabled: _withCtx(({ row }) => [
            _createVNode(_unref(ElSwitch), {
              modelValue: row.is_enabled,
              "onUpdate:modelValue": ($event: any) => ((row.is_enabled) = $event),
              "inline-prompt": "",
              "active-text": _unref(t)('status.enabled', '启用'),
              "active-value": "Y",
              "inactive-text": _unref(t)('status.diabled', '停用'),
              size: "small",
              style: {"--el-switch-off-color":"#f56c6c"},
              "inactive-value": "N",
              onChange: ($event: any) => (onEnabledSwithcChange(row))
            }, null, 8, ["modelValue", "onUpdate:modelValue", "active-text", "inactive-text", "onChange"])
          ]),
          action: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(ElButton), {
                type: "primary",
                size: "small",
                link: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('consignee.buttons.detail', '详 细')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(ElButton), {
                type: "success",
                size: "small",
                link: "",
                onClick: ($event: any) => (actions.editors(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('consignee.buttons.modify', '修 改')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_dropdown, {
                style: {"padding":"2px","margin-left":"12px"},
                trigger: "click",
                size: "small"
              }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_dropdown_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElButton), {
                            size: "small",
                            link: "",
                            type: "info"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('consignee.buttons.syncBasicInfo', '同步基础信息')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_dropdown_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElButton), {
                            size: "small",
                            link: "",
                            type: "info"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('consignee.buttons.syncBankInfo', '同步银行信息')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_dropdown_item, { divided: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElButton), {
                            size: "small",
                            link: "",
                            type: "danger",
                            onClick: ($event: any) => (actions.delete(row))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('consignee.buttons.deleteConsignee', '删除相对方')), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_More)
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1024)
            ])
          ]),
          _: 1
        }, 8, ["pageSize", "currentPage", "columns", "data", "loading", "pagination", "onRegister"])
      ]),
      _: 1
    }),
    _createVNode(PartyBEditor, {
      ref_key: "partyBEditorRef",
      ref: partyBEditorRef
    }, null, 512)
  ], 64))
}
}

})